import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
/* Router Modules */
Vue.use(Router)

// 忽略重复导航到当前路由的错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar
 noCache: true                if set true, the page will no be cached(default is false)
 affix: true                  if set true, the tag will affix in the tags-view
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
]

const idManagePrefix = "manage-";

export const manageRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {
          id: idManagePrefix + "dashboard",
          title: '仪表台', icon: 'el-icon-data-board', affix: true
        }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/list',
    alwaysShow: true, // will always show the root menu
    name: 'product',
    meta: {
      id: idManagePrefix + "product",
      title: '产品',
      icon: 'el-icon-goods',
      roles: ['admin', 'editor'] // you can set roles in root nav
    },
    children: [
      {
        path: 'crawl-list',
        component: () => import('@/views/product/crawl-list'),
        name: 'product-crawl-list',
        meta: {
          id: idManagePrefix + "product-crawl-list",
          title: '采集列表', icon: 'el-icon-download', noCache: true
        }
      },
      {
        path: 'list',
        component: () => import('@/views/product/list'),
        name: 'product-list',
        meta: {
          id: idManagePrefix + "product-list",
          title: '产品列表', icon: 'el-icon-menu', noCache: true
        }
      },
      {
        path: 'variant-list',
        component: () => import('@/views/product/variant-list'),
        name: 'variant-list',
        meta: {
          id: idManagePrefix + "variant-list",
          title: '变种列表', icon: 'el-icon-collection', noCache: true
        }
      },
      {
        path: 'packing-add',
        component: () => import('@/views/product/packing-detail'),
        name: 'packing-add',
        meta: {
          id: idManagePrefix + "packing-list",
          title: '新增包装产品', icon: 'el-icon-box', noCache: true
        },
        hidden: true
      },
      {
        path: 'packing-edit/:id',
        component: () => import('@/views/product/packing-detail'),
        name: 'packing-edit',
        meta: {title: '编辑包装产品', icon: 'el-icon-edit', noCache: true},
        hidden: true
      },
      {
        path: 'add',
        component: () => import('@/views/product/detail'),
        name: 'product-add',
        meta: {title: '新增产品', icon: 'el-icon-plus', noCache: true},
        hidden: true
      },
      {
        path: 'detail/:id',
        component: () => import('@/views/product/detail'),
        name: 'product-detail',
        meta: {title: '产品详情', icon: 'el-icon-view', noCache: true},
        hidden: true
      },
      {
        path: 'preview/:id',
        component: () => import('@/../common/Product'),
        name: 'product-preview',
        meta: {title: '产品预览', icon: 'el-icon-picture', noCache: true},
        hidden: true
      }
    ]
  },

  {
    path: '/user',
    component: Layout,
    redirect: '/user/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/user/index'),
        name: 'user-index',
        meta: {
          id: idManagePrefix + "user-index",
          title: '用户列表', icon: 'el-icon-user', noCache: true
        }
      }
    ]
  },
  {
    path: '/user-inventory',
    component: Layout,
    redirect: '/user-inventory/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/user-inventory/index'),
        name: 'UserInventory',
        meta: {
          id: idManagePrefix + "user-inventory",
          title: '用户库存', icon: 'el-icon-s-custom', noCache: true
        },
      }
    ]
  },
  {
    path: '/inventory-check',
    component: Layout,
    redirect: '/inventory-check/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/inventory-check/index'),
        name: 'inventory-check-index',
        meta: {
          id: idManagePrefix + "inventory-check",
          title: '库存盘点', icon: 'el-icon-collection-tag', noCache: true
        },
      }
    ]
  },
  {
    path: '/recharge',
    component: Layout,
    redirect: '/recharge/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/recharge/index'),
        name: 'recharge-index',
        meta: {
          id: idManagePrefix + "recharge-index",
          title: '充值记录', icon: 'el-icon-wallet', noCache: true
        }
      }
    ]
  },
  {
    path: '/billing',
    component: Layout,
    redirect: '/billing/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/billing/index'),
        name: 'billing-index',
        meta: {
          id: idManagePrefix + "billing-index",
          title: '交易记录', icon: 'el-icon-document', noCache: true
        }
      }
    ]
  },
  {
    path: '/store',
    component: Layout,
    redirect: '/store/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/store/index'),
        name: 'store-index',
        meta: {
          id: idManagePrefix + "store-index",
          title: '店铺列表', icon: 'el-icon-s-shop', noCache: true
        }
      }
    ]
  },
  {
    path: '/sourcing',
    component: Layout,
    redirect: '/sourcing/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/sourcing/index'),
        name: 'sourcing-index',
        meta: {
          id: idManagePrefix + "sourcing-index",
          title: '客户采购', icon: 'el-icon-shopping-cart-full', noCache: true
        }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/index',
    alwaysShow: true, // will always show the root menu
    name: 'orders',
    meta: {
      id: idManagePrefix + "order",
      title: '订单',
      icon: 'el-icon-document-copy'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/order/index'),
        name: 'order-index',
        meta: {
          id: idManagePrefix + "order-index",
          title: '店铺订单', icon: 'el-icon-s-order', noCache: false
        }
      },
      {
        path: 'inventory',
        component: () => import('@/views/order/inventory'),
        name: 'inventory',
        meta: {
          id: idManagePrefix + "order-inventory",
          title: '库存订单', icon: 'el-icon-box', noCache: true
        }
      },
      {
        path: 'purchase',
        component: () => import('@/views/order/order-purchase'),
        name: 'purchase',
        meta: {
          id: idManagePrefix + "order-purchase",
          title: '采购订单', icon: 'el-icon-shopping-cart-2', noCache: true
        }
      },
      {
        path: 'profit/order-by-payment',
        component: () => import('@/views/order/profit-order-by-payment'),
        name: 'profit-order-by-payment',
        meta: {
          id: idManagePrefix + "profit-order-by-payment",
          title: '订单利润统计', icon: 'el-icon-data-line', noCache: true
        }
      },
      {
        path: 'profit/user-summary',
        component: () => import('@/views/order/profit-user-summary'),
        name: 'profit-user-summary',
        meta: {
          id: idManagePrefix + "profit-user-summary",
          title: '客户利润汇总', icon: 'el-icon-s-data', noCache: true
        }
      },
      {
        path: 'profit/user-expense-summary',
        component: () => import('@/views/order/profit-user-expense-summary'),
        name: 'profit-user-expense-summary',
        meta: {
          id: idManagePrefix + "profit-user-expense-summary",
          title: '支出利润统计', icon: 'el-icon-money', noCache: true
        }
      },
      {
        path: 'split/:id',
        component: () => import('@/../common/Order/split'),
        name: 'order-split',
        meta: {title: '分割订单', noCache: true},
        hidden: true
      },
    ]
  },
  {
    path: '/pay',
    component: Layout,
    redirect: '/pay/index',
    children: [
      {
        path: 'index',
        component: () => import('@/../common/Pay'),
        name: 'index',
        meta: {title: 'Pay', noCache: true},
        hidden: true
      }
    ]
  },
  {
    path: '/shipment',
    component: Layout,
    redirect: '/shipment/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/shipment/index'),
        name: 'shipment-index',
        meta: {
          id: idManagePrefix + "shipment-index",
          title: '物流列表', icon: 'el-icon-truck', noCache: true
        }
      }
    ]
  },

  {
    path: '/affiliate',
    component: Layout,
    redirect: '/affiliate/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/affiliate/index'),
        name: 'affiliate-index',
        meta: {
          id: idManagePrefix + "affiliate-index",
          title: '营销列表', icon: 'el-icon-present', noCache: true
        }
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/notify',
    alwaysShow: true, // will always show the root menu
    name: 'sys',
    meta: {
      id: idManagePrefix + "sys",
      title: '系统',
      icon: 'el-icon-setting'
    },
    children: [
      {
        path: 'admin',
        component: () => import('@/views/sys/admin'),
        name: 'sys-admin',
        meta: {
          id: idManagePrefix + "sys-admin",
          title: '员工列表', icon: 'el-icon-user-solid', noCache: true
        }
      },
      {
        path: 'notify',
        component: () => import('@/views/sys/notify'),
        name: 'sys-notify',
        meta: {
          id: idManagePrefix + "sys-notify",
          title: '系统通知', icon: 'el-icon-message', noCache: true
        }
      },
      {
        path: '/notify/edit/:id',
        component: () => import('@/views/sys/notify_edit'),
        name: 'notify-edit',
        meta: {
          title: '通知编辑', icon: 'el-icon-edit', noCache: true
        },
        hidden: true
      }, {
        path: '/notify/add',
        component: () => import('@/views/sys/notify_edit'),
        name: 'notify-add',
        meta: {title: '通知新增', icon: 'el-icon-plus', noCache: true},
        hidden: true
      },
      {
        path: 'inquiry',
        component: () => import('@/views/sys/inquiry'),
        name: 'sys-inquiry',
        meta: {
          id: idManagePrefix + "sys-inquiry",
          title: '官网询价', icon: 'el-icon-chat-line-square', noCache: true
        }
      },
      {
        // 不设 meta.id：不参与 permission_ids 过滤，只要能看到「系统」菜单就能看到这一项。
        // 支持 inbox 属于全员可见的基础功能，逐个账号加权限容易漏（2026-10-22）。
        path: 'app-message',
        component: () => import('@/views/sys/app-message'),
        name: 'sys-app-message',
        meta: {
          title: '用户留言', icon: 'el-icon-chat-dot-round', noCache: true
        }
      },
      {
        path: 'config',
        component: () => import('@/views/sys/config'),
        name: 'sys-config',
        meta: {
          id: idManagePrefix + "sys-config",
          title: '系统配置', icon: 'el-icon-s-tools', noCache: true
        }
      },
      {
        path: 'notify-history',
        component: () => import('@/views/sys/notify-history'),
        name: 'notify-history',
        meta: {
          id: idManagePrefix + "notify-history",
          title: '通知历史', icon: 'el-icon-warning', noCache: true
        }
      },
      {
        path: 'operation-log',
        component: () => import('@/views/sys/operation-log'),
        name: 'sys-operation-log',
        meta: {
          id: idManagePrefix + "sys-operation-log",
          title: '系统日志', icon: 'el-icon-document-checked', noCache: true
        }
      },

    ]
  },
]
export const notFound = [
  // 404 page must be placed at the end !!!
  {path: '*', redirect: '/404', hidden: true}
]
const buildRouter = () => {
  return constantRoutes.concat(manageRoutes).concat(notFound)
}
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  mode: "history",
  routes: buildRouter()
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
